export default __webpack_public_path__ + "6386446dac6a160c9c51810d643c8e06.svg";